import React from "react";
import ContentLoader, { IContentLoaderProps } from "react-content-loader";
import styles from "./ButtonSkeleton.module.scss";

export const ButtonSkeleton: React.FC<IContentLoaderProps> = (props) => (
  <ContentLoader
    speed={2}
    viewBox="0 0 335 36"
    preserveAspectRatio="none"
    backgroundColor="var(--gray-02)"
    foregroundColor="var(--gray-04)"
    className={styles.contentLoader}
    {...props}
  >
    <rect x="0" y="0" rx="4" ry="4" width="335" height="36" />
  </ContentLoader>
);
